import { render, staticRenderFns } from "./PlatformElderByOverall.vue?vue&type=template&id=fcdea346&scoped=true&"
import script from "./PlatformElderByOverall.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdea346",
  null
  
)

export default component.exports